<template>
  <b-input-group class="search-window-group">
    <b-icon-search class="search-icon" />
    <b-button type="submit" class="d-none" />
    <b-form-input
      class="search-window"
      type="search"
      size="sm"
      v-model="text"
      @change="onChange"
      @update="onUpdate"
      @keyup.enter.native="onChange"
      :placeholder="placeholder"
    />
  </b-input-group>
</template>

<style scoped lang="scss">
$info: #00b7c6;
$search-window-bg-color: #f3f3f3;

.search-window-group {
  display: flex;
  flex-direction: row;

  .search-icon {
    z-index: 2;
    position: absolute;
    top: 8px;
    left: 5px;
    font-size: 15px;
    color: $info;
  }

  .search-window {
    z-index: 1;
    padding-left: 25px;
    background-color: $search-window-bg-color;
    border-color: $search-window-bg-color;
    border-radius: 10px;
  }

  .clear-button {
    z-index: 2;
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 0;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>

<script lang="ts">
import { defineComponent, ref } from "vue";
import "../../assets/custom.scss";
export default defineComponent({
  name: "search-window",
  props: {
    placeholder: { type: String, default: "" },
  },
  setup(_props, { emit }) {
    const text = ref("");
    const lock = ref(false);

    const onUpdate = (): void => {
      emit("update", text.value);
    };

    const onChange = (): void => {
      if (lock.value) {
        return;
      }
      emit("change", text.value);
      // 高速入力を防ぐ
      lock.value = true;
      setTimeout(() => {
        lock.value = false;
      }, 100);
    };

    return { text, onUpdate, onChange };
  },
});
</script>
